import { render } from "./customModal.vue?vue&type=template&id=a5f74152&scoped=true"
import script from "./customModal.js?vue&type=script&lang=js"
export * from "./customModal.js?vue&type=script&lang=js"

import "./customModal.vue?vue&type=style&index=0&id=a5f74152&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f74152"]])

export default __exports__